import req from '../req'
// 社群关联设置

// 获取社群列表
export function getMemberShipList (params) {
  return req.get('/salesperson/customer-base/get-list', params)
}

// 获取社群导出列表
export function getExportList (params) {
  return req.get('/salesperson/customer-base/get-export-count', params)
}

// 导出社群
export function exportList (params) {
  return req.get('/salesperson/customer-base/get-export-list', params)
}
